import { useEffect, useState } from "react";
import PromocodesApi from "../../../api/promocodesApi";
import { ReactComponent as CrossIcon } from "../../../assets/General/close.svg";
import ModalWindow from "../../../components/ModalWindow/ModalWindow";
import StandartButton from "../../../components/StandartButton/StandartButton";
import {
  DiscountPromocode,
  PromocodesFilters,
  PromocodesParamsAvailable,
} from "../../../types/Promocodes";
import CreatePromocode from "./CreatePromocode/CreatePromocode";
import s from "./Promocodes.module.css";
import PromocodesFiltersSection from "./PromocodesFilters/PromocodesFilters";
import PromocodesTable from "./PromocodesTable/PromocodesTable";

import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import TripleDotPoperMenu from "../../../components/TripleDotPoperMenu/TripleDotPoperMenu";
import Notify from "../../../utils/toaster";
import { InfoPromocode } from "./InfoPromocode/InfoPromocode";

const Promocodes = () => {
  const token = localStorage.getItem("token");
  const [filters, setFilters] = useState<PromocodesFilters>({
    page: 1,
    limit: 10,
  });
  const [promocodes, setPromocodes] = useState<DiscountPromocode[]>([]);
  const [actionLoaders, setActionLoaders] = useState({
    fetchPromocodesLoader: false,
  });
  const [paramsAvailable, setParamsAvailable] = useState<
    PromocodesParamsAvailable | undefined
  >();
  const [selectedPromocode, setSelectedPromocode] = useState<
    DiscountPromocode | undefined
  >();
  const [createPromocodeModal, setCreatePromocodeModal] = useState(false);
  const [promocodeInfoModal, setPromocodeInfoModal] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);

  const menuItems = [
    { title: "Update", action: () => setCreatePromocodeModal(true) },
    {
      title: "Delete",
      action: () => setDeleteConfirmModal(true),
      styles: { color: "red" },
    },
  ];

  const getPromocodes = async () => {
    if (!token) return;
    setActionLoaders((prev) => ({ ...prev, fetchPromocodesLoader: true }));
    const response = await PromocodesApi.getDiscountPromocodes(token, filters);

    setActionLoaders((prev) => ({ ...prev, fetchPromocodesLoader: false }));
    if (response.status && response.promocodes && response.paramsAvailable) {
      setPromocodes(response.promocodes);
      setParamsAvailable(response.paramsAvailable);
    }
  };

  useEffect(() => {
    getPromocodes();
  }, [filters]);

  useEffect(() => {
    setPromocodeInfoModal(selectedPromocode ? true : false);
  }, [selectedPromocode]);

  const deleteDiscountPromocode = async () => {
    if (!token || !selectedPromocode) return;
    const response = await PromocodesApi.deleteDiscountPromocode(
      token,
      selectedPromocode._id,
    );
    if (response.status) {
      setPromocodes((prev) =>
        prev.filter((el) => el._id !== selectedPromocode._id),
      );
      setSelectedPromocode(undefined);
      setPromocodeInfoModal(false);
      setDeleteConfirmModal(false);
    }
    if (!response.status && response.message) {
      Notify(response.message);
    }
  };

  return (
    <div className={s.container}>
      <div className={s.actionBlock}>
        <StandartButton
          action={() => setCreatePromocodeModal(true)}
          buttonTitle="Create Promocode"
        />
      </div>
      <div className={s.filtersBlock}>
        <PromocodesFiltersSection
          filters={filters}
          paramsAvailable={paramsAvailable}
          setFilters={setFilters}
        />
      </div>
      <div className={s.tableBlock}>
        {promocodes.length ? (
          <PromocodesTable
            count={paramsAvailable?.totalAmount ?? 0}
            page={filters.page}
            rows={promocodes}
            rowsPerPage={filters.limit}
            setPage={(page: number) =>
              setFilters((prev) => ({ ...prev, page: page }))
            }
            setRowsPerPage={(limit: number) =>
              setFilters((prev) => ({ ...prev, limit: limit }))
            }
            setSelectedPromocode={setSelectedPromocode}
          />
        ) : (
          <h3 className={s.noFlexpassText}>No Promocodes</h3>
        )}
      </div>
      <ModalWindow
        isOpen={createPromocodeModal}
        setIsOpen={setCreatePromocodeModal}
        width="fit-content"
      >
        <CreatePromocode
          setCreatePromocodeModal={setCreatePromocodeModal}
          setPromocodes={setPromocodes}
          setSelectedPromocode={setSelectedPromocode}
          isUpdatePromocode={selectedPromocode ? true : false}
          promocodePropsData={selectedPromocode}
        />
      </ModalWindow>
      {selectedPromocode && (
        <ModalWindow
          isOpen={promocodeInfoModal}
          alternativeCloseFunction={() => {
            setPromocodeInfoModal(false);
            setSelectedPromocode(undefined);
          }}
          width="fit-content"
          hiddenCloseBtn
        >
          <div className={s.headerActionBlock}>
            <TripleDotPoperMenu menuItemDta={menuItems} />
            <div
              onClick={() => {
                setSelectedPromocode(undefined);
                setPromocodeInfoModal(false);
              }}
              style={{ cursor: "pointer" }}
            >
              <CrossIcon className={s.closeIcon} />
            </div>
          </div>
          <InfoPromocode promocode={selectedPromocode} />
        </ModalWindow>
      )}
      <ConfirmationModal
        confirmFunc={deleteDiscountPromocode}
        modalVisible={deleteConfirmModal}
        setModalVisible={setDeleteConfirmModal}
        confirmTitle="Are you sure you want to delete this Promocode?"
      />
    </div>
  );
};

export default Promocodes;
